var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 0.666748H2.66634C1.93301 0.666748 1.33301 1.26675 1.33301 2.00008V11.3334H2.66634V2.00008H10.6663V0.666748ZM9.99967 3.33341H5.33301C4.59967 3.33341 4.00634 3.93341 4.00634 4.66675L3.99967 14.0001C3.99967 14.7334 4.59301 15.3334 5.32634 15.3334H12.6663C13.3997 15.3334 13.9997 14.7334 13.9997 14.0001V7.33341L9.99967 3.33341ZM5.33301 14.0001V4.66675H9.33301V8.00008H12.6663V14.0001H5.33301Z",
    fill: "#1859A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopy);
export default __webpack_public_path__ + "static/media/file_copy.68e6532d.svg";
export { ForwardRef as ReactComponent };